<template>
  <v-layout row>
    <v-flex xs12>
      <v-card class="elevation-11">
        <v-toolbar color="blue-grey lighten-5">
          <v-toolbar-title class="ttl">{{downloadType}}</v-toolbar-title>
          <span v-show="downloadType!=='Tracks, songs, and exercises'" class="ml-2 tracks">(Click link to view/download)</span>
        </v-toolbar>

      <v-list v-if="downloadType !=='Tracks, songs, and exercises'"  one-line>
          <template v-for="(download, index) in downloads">
            <v-list-tile
              class="mt-1"
              ripple
              :key="download.index"
            >
              <v-list-tile-content>
                <v-list-tile-sub-title class="text--primary dl">
                  <a :href=download.downloadURL class="mr-3" target="_blank"><span class="dlTitle">{{download.title}}</span></a>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="index + 1 < downloads.length" :key="index"></v-divider>
          </template>
        </v-list>

    <!-- for tracks -->

      <v-list v-else one-line>
        <section id="personal" v-show="personalTracks.length > 0">
          <h4 class="ml-3 mt-2">Your personal tracks</h4>
            <template v-for="(item, index) in personalTracks">
              <v-list-tile
                class="mt-1"
                ripple
                :key="item.index"
              >
                <v-list-tile-content>
                  <v-list-tile-sub-title class="text--primary dl">
                    <a :href=item.downloadURL target="_blank" class="mr-1">{{item.title}}</a>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider v-if="index + 1 < item.length" :key="index"></v-divider>
            </template>
            <hr/>
        </section>

        <section id="all songs">
          <h4 class="ml-3 mt-2">Songs</h4>
            <template v-for="(item, index) in songs">
              <v-list-tile
                class="mt-1"
                ripple
                :key="item.index"
              >
                <v-list-tile-content>
                  <v-list-tile-sub-title class="text--primary dl">
                    <a :href=item.downloadURL target="_blank" class="mr-1">{{item.title}}</a>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider v-if="index + 1 < item.length" :key="index"></v-divider>
            </template>
            <hr/>
        </section>
        <section id="exercises">
          <h4 class="ml-3">Exercises</h4>
            <template v-for="(item, index) in allTracks">
              <v-list-tile
                class="mt-1"
                ripple
                :key="item.index"
              >
                <v-list-tile-content>
                  <v-list-tile-sub-title class="text--primary dl">
                    <a :href=item.downloadURL target="_blank" class="mr-1">{{item.title}}</a>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider v-if="index + 1 < item.length" :key="index"></v-divider>
            </template>
        </section>

        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"
export default {
  mounted() {
    this.$store.state.type === "Tracks, songs, and exercises" ? this.setTracks(): ''
  },
  data() {
    return {
      allTracks: [],
      personalTracks: [],
      songs: []
    }
  },
  computed: {
    ...mapState([
      "notes",
      "handouts",
      "tracks",
      "type",
      "finalTracks",
      "user"
    ]),
    topics() {
      return this.$store.getters.getTargetedExercises
    },
    downloadType() {
      return this.type
    },
    downloads() {
      switch (this.downloadType) {
        case "Dryboard notes":
          return this.notes.filter(el => {
            return (
              el.viewableBy === this.user.userId ||
              this.user.userId === this.$store.state.adminId
            )
          }).sort((a, b) => a.uploaded < b.uploaded)
          break
        case "Handouts":
          return this.handouts.filter(el => {
            return (
              el.viewableBy === "all" ||
              el.viewableBy === this.user.userId ||
              this.user.userId === this.$store.state.adminId
            )
          }).sort((a, b) => a.title > b.title)
          break
        case "Final Tracks":
          return this.finalTracks.filter(el => {
            return (
              el.viewableBy === "all" ||
              el.viewableBy === this.user.userId ||
              this.user.userId === this.$store.state.adminId
            )
          }).sort((a, b) => a.title > b.title)
          break

        case "Targeted-Exercises":
          return this.topics
          break

        default:
          break
      }
    }
  },
  methods: {
    setTracks() {
      let arrAll = []
      let arrPersonal = []
      let arrSongs = []
      this.tracks.forEach( el => {
        el.viewableBy === "song for all" ? arrSongs.push(el) : ''
        el.viewableBy === "all" || this.user.userId === this.$store.state.adminId ? arrAll.push(el) : ''
        el.viewableBy === this.user.userId ? arrPersonal.push(el) : ''
      })
      this.allTracks = arrAll.sort().sort((a, b) => a.title > b.title)
      this.personalTracks = arrPersonal.sort().sort((a, b) => a.title > b.title)
      this.songs = arrSongs.sort().sort((a, b) => a.title > b.title)
    }
  },
}
</script>

<style scoped>

a {
  color: #3d3d3d;
  font-size: 12px;
  margin-left: 5px;
}

.dlTitle {
    font-size: .95rem;
    white-space: -moz-pre-wrap !important;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    white-space: pre-wrap;       /* css-3 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
    white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
    word-break: break-all;
    white-space: normal;
}

.tracks {
  font-size: 13px;
}

.ttl {
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  font-weight: bold;
}

.dl {
  font-family: "Lato", sans-serif;
  font-weight: 400;
}

hr {
margin: 10px;
}
</style>